import React, { lazy, memo } from 'react';
import { EyeIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const slides = [{
  label: 'Tomo 3 · Fracciones',
  title: 'El Método de la Pizza',
  desc: 'Cómo explicar fracciones equivalentes usando dibujos simples. Tu hijo entiende visualmente por qué 1/2 es lo mismo que 2/4, sin memorizar reglas vacías.',
  image: 'https://cdn.magicpatterns.com/uploads/duzQfcAKgajuJndCHdAVLh/pizza.webp'
}, {
  label: 'Tomo 3 · Multiplicación',
  title: 'La Caja de los Tesoros',
  desc: 'Un sistema visual para que la multiplicación deje de ser una tabla de memoria y se convierta en un juego de agrupar objetos. Ideal para niños visuales.',
  image: 'https://cdn.magicpatterns.com/uploads/jCtnDxiB8JB2K31a74etBL/caja_de_tesoros.webp'
}, {
  label: 'Tomo 3 · División',
  title: 'La Fiesta de los Caramelos',
  desc: 'Dividir es repartir en partes iguales. Con una analogía simple y cotidiana, tu hijo entiende la división sin frustrarse ni sentir que "no le entra".',
  image: 'https://cdn.magicpatterns.com/uploads/sz6D4UHMQmtuF3x3AACXym/la_fiesta_.webp'
}];
export function ContentPreview() {
  return <section className="py-12 md:py-16 bg-white border-y border-slate-200" aria-label="Vista previa de métodos" data-id="element-69">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-70">
        <FadeIn data-id="element-71">
          <div className="text-center mb-8" data-id="element-72">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 mb-4 rounded-full border border-primary/30 bg-primary/10" data-id="element-73">
              <EyeIcon className="w-4 h-4 text-primary-dark" aria-hidden="true" data-id="element-74" />
              <span className="text-primary-dark text-[10px] md:text-xs font-bold uppercase tracking-widest" data-id="element-75">
                Mirá adentro del sistema
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-slate-900 mb-4" data-id="element-76">
              Un vistazo a los Métodos Visuales
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto text-base" data-id="element-77">
              Ejemplos reales de cómo transformar conceptos abstractos en
              imágenes claras que tu hijo puede entender en minutos.
            </p>
          </div>
        </FadeIn>

        {/* Vertical stacked layout — one method below the other */}
        <div className="max-w-4xl mx-auto space-y-6 md:space-y-8" data-id="element-78">
          {slides.map((slide, i) => <FadeIn key={slide.image} delay={0.1 + i * 0.1} data-id="element-79">
              <div className="bg-surfaceLight/50 rounded-3xl border border-slate-100 p-4 md:p-6 shadow-soft" data-id="element-80">
                <div className="grid md:grid-cols-2 gap-5 md:gap-8 items-center" data-id="element-81">
                  {/* Method illustration */}
                  <div className="relative order-1" data-id="element-82">
                    <div className="absolute inset-0 z-0 pointer-events-none" aria-hidden="true" style={{
                  background: 'radial-gradient(circle at center, rgba(45,212,191,0.18) 0%, rgba(45,212,191,0) 70%)',
                  filter: 'blur(20px)'
                }} data-id="element-83" />
                    <img src={slide.image} alt={`${slide.title} — método visual del ${slide.label}`} className="relative z-10 w-full h-auto rounded-2xl shadow-soft border border-white" width={1024} height={1024} loading="lazy" decoding="async" data-id="element-84" />
                  </div>

                  {/* Text */}
                  <div className="order-2" data-id="element-85">
                    <span className="inline-block text-xs font-bold text-primary-dark bg-white px-3 py-1.5 rounded-xl mb-4 shadow-sm border border-slate-100" data-id="element-86">
                      {slide.label}
                    </span>
                    <h3 className="font-heading text-2xl md:text-3xl font-extrabold text-slate-900 mb-3 leading-tight" data-id="element-87">
                      {slide.title}
                    </h3>
                    <p className="text-slate-700 text-base leading-snug" data-id="element-88">
                      {slide.desc}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}